<template>
    <div>
        <div class="mb-3">
            <label>Cari Kontak:</label>
            <input 
                type="text" 
                v-model="searchQuery" 
                @input="searchContact" 
                class="form-control" 
                placeholder="Nama atau nomor WhatsApp"
                style="width: 300px; display: inline-block; margin-left: 10px;"
            />
        </div>
        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <button v-on:click="pauseFollowUp(props.row)" v-if="props.row.status === 'active'" class="btn btn-warning text-white margin5">
                        <i class="fas fa-pause"></i> Pause
                    </button>
                    <button v-on:click="resumeFollowUp(props.row)" v-if="props.row.status === 'paused'" class="btn btn-success text-white margin5">
                        <i class="fas fa-play"></i> Resume
                    </button>
                    <button v-on:click="resumeFollowUp(props.row)" v-if="props.row.status === 'stopped'" class="btn btn-primary text-white margin5">
                        <i class="fas fa-play"></i> Start
                    </button>
                    <button v-on:click="stopFollowUp(props.row)" v-if="props.row.status !== 'stopped' && props.row.status !== 'completed'" class="btn btn-danger text-white margin5">
                        <i class="fas fa-stop"></i> Stop
                    </button>
                </span>
                <span v-else-if="props.column.field == 'status'">
                    <span v-if="props.row.status === 'active'" class="badge badge-success">Aktif</span>
                    <span v-else-if="props.row.status === 'paused'" class="badge badge-warning">Paused</span>
                    <span v-else-if="props.row.status === 'completed'" class="badge badge-info">Selesai</span>
                    <span v-else-if="props.row.status === 'stopped'" class="badge badge-danger">Dihentikan</span>
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchQuery: '',
            table: {
                isLoading: false,
                columns: [
                    { label: 'Nama Follow Up', field: 'follow_up_name', sortable: true },
                    { label: 'Kontak', field: 'contact_name', sortable: true },
                    { label: 'Nomor Kontak', field: 'contact_number', sortable: true },
                    { label: 'Step Saat Ini', field: 'current_step', sortable: true },
                    { label: 'Status', field: 'status', sortable: true },
                    { label: 'Aksi', field: 'action', sortable: false }
                ],
                rows: [],
                total_records: 0,
                serverParams: {
                    page: 1,
                    limit: 10,
                    columnFilters: {}
                }
            }
        };
    },
    methods: {
        async loadItems() {
            this.table.isLoading = true;
            try {
                const params = {
                    page: this.table.serverParams.page,
                    limit: this.table.serverParams.limit,
                    columnFilters: JSON.stringify(this.table.serverParams.columnFilters)
                };
                let response = await this.$store.dispatch("followup/followup_contacts_list", params);
                const contacts = response.data.data.follow_up_contacts || [];
                // Transform data to flatten nested objects
                this.table.rows = contacts.map(item => ({
                    ...item,
                    follow_up_name: item.follow_up ? item.follow_up.name : '-',
                    contact_name: item.contact ? item.contact.name : '-',
                    contact_number: item.contact ? item.contact.number : '-',
                    follow_up_id: item.follow_up_id,
                    contact_id: item.contact_id
                }));
                this.table.total_records = response.data.data.total || 0;
            } catch (err) {
                this.$toast.error("Gagal memuat data");
            } finally {
                this.table.isLoading = false;
            }
        },
        searchContact() {
            // Update column filters with search query (cari berdasarkan NAMA atau NOMOR)
            const q = this.searchQuery ? String(this.searchQuery).trim() : '';
            if (q) {
                const isNumber = /^[0-9+\-\s]+$/.test(q);
                this.table.serverParams.columnFilters = isNumber
                    ? { contact_number: q.replace(/[\s\-+]/g, '') }
                    : { contact_name: q };
            } else {
                this.table.serverParams.columnFilters = {};
            }
            this.table.serverParams.page = 1;
            this.loadItems();
        },
        async pauseFollowUp(row) {
            try {
                await this.$store.dispatch("followup/followup_contact_pause", {
                    follow_up_id: row.follow_up_id,
                    contact_id: row.contact_id
                });
                this.$toast.success("Follow up di-pause");
                this.loadItems();
            } catch (err) {
                this.$toast.error("Gagal pause follow up");
            }
        },
        async resumeFollowUp(row) {
            try {
                await this.$store.dispatch("followup/followup_contact_resume", {
                    follow_up_id: row.follow_up_id,
                    contact_id: row.contact_id
                });
                this.$toast.success("Follow up di-resume");
                this.loadItems();
            } catch (err) {
                this.$toast.error("Gagal resume follow up");
            }
        },
        async stopFollowUp(row) {
            if (!confirm("Hentikan follow up untuk kontak ini?")) return;
            try {
                await this.$store.dispatch("followup/followup_contact_stop", {
                    follow_up_id: row.follow_up_id,
                    contact_id: row.contact_id
                });
                this.$toast.success("Follow up dihentikan");
                this.loadItems();
            } catch (err) {
                this.$toast.error("Gagal menghentikan follow up");
            }
        },
        onPageChange(params) {
            this.table.serverParams.page = params.currentPage;
            this.loadItems();
        },
        onPerPageChange(params) {
            this.table.serverParams.limit = params.currentPerPage;
            this.loadItems();
        },
        onSortChange() {
            this.loadItems();
        },
        onColumnFilter(params) {
            this.table.serverParams.columnFilters = params;
            this.loadItems();
        }
    },
    mounted() {
        this.loadItems();
    }
};
</script>

<style scoped>
.margin5 {
    margin: 2px;
}
</style>


